(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .component('cronogramaFungicidasGrid', {
      templateUrl: 'views/cronograma_fungicidas/grid.html',
      bindings: {
        schedules: '<',
        onUpdate: '&'
      },
      controller: 'CronogramaFungicidasGridCtrl'
    });
}());
